module.exports = __webpack_public_path__ + "img/wallet-active.55452a7d.svg";